"use strict";
/**
 * Les langues livrées — séparées des catalogues pour qu'une surface puisse
 * demander « cette langue est-elle livrée ? » sans embarquer un seul texte.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUES_REPLI = exports.LANGUE_PAR_DEFAUT = exports.LANGUES = void 0;
exports.estLangueLivree = estLangueLivree;
exports.languesUtilisables = languesUtilisables;
exports.langueEffective = langueEffective;
exports.langueSuivante = langueSuivante;
exports.peutChoisirLangue = peutChoisirLangue;
/** Langues livrées ensemble dès le MVP — le français par défaut. */
exports.LANGUES = ['fr', 'en'];
exports.LANGUE_PAR_DEFAUT = 'fr';
function estLangueLivree(langue) {
    return exports.LANGUES.some((candidate) => candidate === langue);
}
/**
 * Le comportement d'avant le choix par pays : français par défaut, bascule français ↔ anglais.
 * C'est aussi le repli hors connexion et avant la réponse du serveur — une application qui
 * démarre sans réseau ne reste pas sans langue.
 */
exports.LANGUES_REPLI = { defaut: exports.LANGUE_PAR_DEFAUT, servies: exports.LANGUES };
/**
 * Confronte ce que le serveur dit d'un pays au catalogue que l'application embarque.
 *
 * Une langue servie que ce binaire ne livre pas — un pays qui a pris une langue ajoutée après la
 * publication de cette version — ne peut pas être affichée : elle est écartée plutôt que d'être
 * choisie et de faire planter le traducteur. Rien d'exploitable ne reste : repli.
 */
function languesUtilisables(recues) {
    const servies = exports.LANGUES.filter((langue) => recues.servies.includes(langue));
    const [premiere] = servies;
    if (premiere === undefined)
        return exports.LANGUES_REPLI;
    const defaut = servies.find((langue) => langue === recues.defaut) ?? premiere;
    return { defaut, servies };
}
/**
 * La langue à afficher pour un compte : la sienne si le pays la sert, sinon celle du pays.
 *
 * Un compte créé quand le pays servait l'anglais le garde dans sa fiche ; si le pays ne la sert
 * plus, l'interface passe à la langue par défaut plutôt que de rester dans une langue que le profil
 * ne permettrait plus de choisir.
 */
function langueEffective(langueCompte, langues) {
    return langues.servies.find((langue) => langue === langueCompte) ?? langues.defaut;
}
/** La langue suivante dans l'ordre des langues servies, en boucle. Une seule langue : la même. */
function langueSuivante(courante, servies) {
    const position = servies.indexOf(courante);
    return servies[(position + 1) % servies.length] ?? courante;
}
/** Un choix n'a de sens qu'à partir de deux langues. */
function peutChoisirLangue(langues) {
    return langues.servies.length >= 2;
}
//# sourceMappingURL=langues.js.map